import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import { stringTruncateFormat } from '../../../../utils';

// eslint-disable-next-line no-unused-vars
const ExecLinkPanel = props => (
  <article className="panel panel-heading_padding-large panel-default">
    <div className="panel-heading text-center panel-inner-border-bottom">
      <h2 className="panel-title">
        <i className="fa fa-link" /> {t('Ссылка для выполнения задания')}
      </h2>
    </div>
    <div className="panel-body">
      <p>
        <i>{t('Для выполнения задания перейдите по следующей ссылке')}:</i>
      </p>
      <p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={props.taskExec.taskLink}
        >
          {stringTruncateFormat(props.taskExec.taskLink, 50)}
        </a>
      </p>

      <a
        className="btn btn-success btn-block"
        target="_blank"
        rel="noopener noreferrer"
        href={props.taskExec.taskLink}
      >
        {t('Перейти на страницу задания')}
      </a>
    </div>
  </article>
);

ExecLinkPanel.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  taskExec: PropTypes.shape({
    taskLink: PropTypes.string.isRequired
  }).isRequired
};

export default ExecLinkPanel;



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/ExecDescBlock/ExecLinkPanel.js